import { useState } from "react";
import { Loader2 } from "lucide-react";
import { questionFor, unitWord } from "@/lib/billsLanguage";

// Inline contextual conversion answer: value = base units in ONE source unit.
export const ConversionQuestion = ({ line, initial, onSubmit, onCancel, busy, label }) => {
  const [val, setVal] = useState(initial != null ? String(initial) : "");
  const [err, setErr] = useState(null);
  const id = `conv-input-${line.line_id}`;
  const errId = `${id}-error`;

  const submit = (e) => {
    e.preventDefault();
    const n = Number(String(val).replace(/,/g, ""));
    if (!val.trim() || !Number.isFinite(n) || n <= 0) {
      setErr("Enter a number greater than 0");
      return;
    }
    setErr(null);
    onSubmit({ base_uom: line.target_base_uom, multiplier: n });
  };

  return (
    <form onSubmit={submit} className="mt-2 space-y-2" data-testid={`conversion-question-${line.line_id}`} noValidate>
      <label htmlFor={id} className="block text-[15px] font-medium text-archival-primary">
        {label || questionFor(line)}
      </label>
      <div className="flex items-stretch gap-2">
        <div className="flex-1 min-w-0 flex items-center rounded-md border border-[#E4E0D8] bg-white focus-within:ring-2 focus-within:ring-[var(--action)]">
          <input
            id={id}
            data-testid={`conversion-input-${line.line_id}`}
            inputMode="decimal"
            enterKeyHint="done"
            value={val}
            onChange={(e) => setVal(e.target.value)}
            aria-invalid={!!err}
            aria-describedby={err ? errId : undefined}
            className="flex-1 min-w-0 h-12 px-3 bg-transparent text-[18px] font-mono focus:outline-none"
          />
          <span className="pr-3 text-[14px] text-archival-secondary">{unitWord(line.target_base_uom)}</span>
        </div>
        <button
          type="submit"
          disabled={busy}
          data-testid={`conversion-submit-${line.line_id}`}
          className="h-12 px-5 rounded-md text-white text-[15px] font-semibold disabled:opacity-60 transition-colors"
          style={{ backgroundColor: "var(--action)" }}
        >
          {busy ? <Loader2 size={16} className="animate-spin" /> : "Confirm"}
        </button>
      </div>
      {err && <p id={errId} role="alert" className="text-[13px] text-red-700" data-testid={`conversion-error-${line.line_id}`}>{err}</p>}
      {onCancel && (
        <button type="button" onClick={onCancel} className="text-[13px] text-archival-secondary underline underline-offset-2 min-h-[44px]"
          data-testid={`conversion-cancel-${line.line_id}`}>Cancel</button>
      )}
    </form>
  );
};
